module.exports = "/images/vendor/desiigner-svg/svg/logos/48-ore-slovenia.svg?24188e3619d29204e5d8ac9e9d180bfc";